"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.execSyntax = void 0;
const lodash_get_1 = __importDefault(require("lodash.get"));
function execPath(items, context) {
    const fullPathString = items.reduce((acc, item) => {
        if (item.type === "identifier" || item.type === "property") {
            return acc + item.text;
        }
        if (item.type === "predicate") {
            const predicate = String(execSyntax(item.expression, context));
            return `${acc}[${predicate}]`;
        }
        return acc;
    }, "");
    const result = (0, lodash_get_1.default)(context, fullPathString);
    if (typeof result === "undefined") {
        console.warn(`Path "${fullPathString}" does not exist in context`);
    }
    return [(0, lodash_get_1.default)(context, fullPathString), fullPathString];
}
function execUnary(type, operand, context) {
    const value = execSyntax(operand, context);
    return type === "not" ? !value : false;
}
function execOperator(type, leftExp, rightExp, context) {
    const leftResult = execSyntax(leftExp, context);
    const rightResult = execSyntax(rightExp, context);
    if (leftResult === undefined ||
        leftResult === "" ||
        rightResult === undefined ||
        rightResult === "") {
        return undefined;
    }
    const left = Number(leftResult);
    const right = Number(rightResult);
    switch (type) {
        case "add":
            return left + right;
        case "subtract":
            return left - right;
        case "modulus":
            return left % right;
        case "divide":
            return left / right;
        case "multiply":
            return left * right;
        default:
            return undefined;
    }
}
const supportedComparisonTypes = ["string", "number", "boolean", "undefined"];
function execComparison(type, leftExp, rightExp, context) {
    const left = execSyntax(leftExp, context);
    const right = execSyntax(rightExp, context);
    if (!supportedComparisonTypes.includes(typeof left) ||
        !supportedComparisonTypes.includes(typeof right)) {
        throw new Error(`Cannot compare ${typeof left} and ${typeof right}`);
    }
    if (type === "notequal") {
        return toCompareValue(left) !== toCompareValue(right);
    }
    if (type === "equal") {
        return toCompareValue(left) === toCompareValue(right);
    }
    if (left === undefined ||
        left === "" ||
        right === undefined ||
        right === "") {
        return false;
    }
    switch (type) {
        case "lessthan":
            return Number(left) < Number(right);
        case "greaterthan":
            return Number(left) > Number(right);
        case "lessthanorequal":
            return Number(left) <= Number(right);
        case "greaterthanorequal":
            return Number(left) >= Number(right);
        default:
            return false;
    }
}
function toCompareValue(value) {
    switch (typeof value) {
        case "string":
            return value;
        case "number":
            return String(value);
        case "boolean":
            return value ? "1" : "0";
        default:
            return "";
    }
}
function execConjunction(leftExp, rightExp, context) {
    return execSyntax(leftExp, context) && execSyntax(rightExp, context);
}
function execDisjunction(leftExp, rightExp, context) {
    return execSyntax(leftExp, context) || execSyntax(rightExp, context);
}
function execTernary(conditional, truthy, falsy, context) {
    return execSyntax(conditional, context)
        ? execSyntax(truthy, context)
        : execSyntax(falsy, context);
}
function execFunctionCall(path, args, context) {
    const [fn, pathString] = execPath(path.items, context);
    if (typeof fn !== "function") {
        throw new Error(`Function call cannot call a function: ${pathString}`);
    }
    return fn(args, context);
}
function execMap(items, context) {
    const map = new Map();
    for (const item of items) {
        const key = execSyntax(item.key, context);
        const value = execSyntax(item.value, context);
        map.set(key, value);
    }
    return map;
}
function execArray(items, context) {
    return items.map((item) => execSyntax(item, context));
}
function execSyntax(exp, context) {
    switch (exp.type) {
        case "string":
            return exp.value;
        case "number":
            return exp.value;
        case "boolean":
            return exp.token.value;
        case "path":
            return execPath(exp.items, context)[0];
        case "unary":
            return execUnary(exp.token.type, exp.operand, context);
        case "operator":
            return execOperator(exp.token.type, exp.left, exp.right, context);
        case "comparison":
            return execComparison(exp.token.type, exp.left, exp.right, context);
        case "conjunction":
            return execConjunction(exp.left, exp.right, context);
        case "disjunction":
            return execDisjunction(exp.left, exp.right, context);
        case "ternary":
            return execTernary(exp.conditional, exp.truthy, exp.falsy, context);
        case "call":
            return execFunctionCall(exp.path, exp.args, context);
        case "map":
            return execMap(exp.items, context);
        case "array":
            return execArray(exp.items, context);
        default:
            return undefined;
    }
}
exports.execSyntax = execSyntax;
//# sourceMappingURL=index.js.map